<template>
    <PersonalInfoPolicy20251124Content />
</template>

<script>
import PersonalInfoPolicy20251124Content from '@/views/policy/common/PersonalInfoPolicy20251124Content.vue';

export default {
    name: 'PrivacyPolicy20251124',
    components: {
        PersonalInfoPolicy20251124Content,
    },
};
</script>
